import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, combineLatestWith, filter, mergeMap } from 'rxjs/operators';
import {
	CART_UPDATE_STOCK_ALL,
	MENU_FAILURE,
	MENU_FIND_ALL,
	MENU_FIND_ALL_SUCCESS,
	MENU_FIND_SUCCESS,
	MENU_UPDATE_LOADING,
	SUBCATEGORY_FIND,
} from '@store/actions';
import { MenuService } from '@core/services';
import { LocalChannel } from '@core/enums';
import { findDefaultMenuForChannel } from '@core/domain/menu';
import { selectLocalChannelId } from '../selectors';

@Injectable()
export class MenuEffects {
	constructor(
		private actions$: Actions,
		private store: Store,
		private menuService: MenuService
	) {}

	findAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MENU_FIND_ALL),
			combineLatestWith(this.store.select(selectLocalChannelId)),
			filter(([, localChannelId]) => !!localChannelId),
			mergeMap(() => {
				this.store.dispatch(MENU_UPDATE_LOADING({ loading: true }));
				return this.menuService.findAll().pipe(
					mergeMap(({ data: menuList }) => {
						const menu = findDefaultMenuForChannel(menuList, LocalChannel.JuvoOlo);

						return [
							MENU_FIND_SUCCESS({ menu }),
							MENU_FIND_ALL_SUCCESS({ menuList }),
							MENU_UPDATE_LOADING({ loading: false }),
							CART_UPDATE_STOCK_ALL({ menuId: menu?.idMenu }),
							SUBCATEGORY_FIND(),
						];
					}),
					catchError(error => of(MENU_FAILURE({ error })))
				);
			})
		)
	);
}
